// extracted by mini-css-extract-plugin
module.exports = {"root":"📦ContactDetailModify__root--2QgMc","labelledValue":"📦ContactDetailModify__labelledValue--2xCjH","labelledSelect":"📦ContactDetailModify__labelledSelect--yaBrU"};